import jsPDF from "jspdf";

// ─── Carga logo desde /public/lux_logo.PNG ───────────────────────────────────
async function loadLogoDataUrl() {
  return new Promise((resolve) => {
    try {
      const img = new window.Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) { resolve(null); return; }
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = "/lux_logo.PNG";
    } catch { resolve(null); }
  });
}

async function loadImageDataUrl(src) {
  return new Promise((resolve) => {
    if (!src) {
      resolve(null);
      return;
    }
    try {
      const img = new window.Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch {
      resolve(null);
    }
  });
}

// ─── Carga imagen con dimensiones preservadas ──────────────────────────────────
async function loadImageWithDimensions(src) {
  return new Promise((resolve) => {
    if (!src) {
      resolve({ dataUrl: null, width: 0, height: 0 });
      return;
    }
    try {
      const img = new window.Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve({ dataUrl: null, width: 0, height: 0 });
          return;
        }
        ctx.drawImage(img, 0, 0);
        resolve({
          dataUrl: canvas.toDataURL("image/jpeg"),
          width: img.naturalWidth || img.width,
          height: img.naturalHeight || img.height
        });
      };
      img.onerror = () => resolve({ dataUrl: null, width: 0, height: 0 });
      img.src = src;
    } catch {
      resolve({ dataUrl: null, width: 0, height: 0 });
    }
  });
}

// ─── Crop center de imagen para llenar recuadro manteniendo aspecto ─────────────
async function cropCenterImage(src, boxWidth, boxHeight) {
  return new Promise((resolve) => {
    if (!src) {
      resolve(null);
      return;
    }
    try {
      const img = new window.Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const boxAspect = boxWidth / boxHeight;
        const imgAspect = img.width / img.height;
        let cropWidth, cropHeight, srcX, srcY;

        if (imgAspect > boxAspect) {
          // Imagen más ancha: crop horizontal
          cropHeight = img.height;
          cropWidth = img.height * boxAspect;
          srcY = 0;
          srcX = (img.width - cropWidth) / 2;
        } else {
          // Imagen más alta: crop vertical
          cropWidth = img.width;
          cropHeight = img.width / boxAspect;
          srcX = 0;
          srcY = (img.height - cropHeight) / 2;
        }

        const canvas = document.createElement("canvas");
        canvas.width = boxWidth * 3;  // Alta resolución para impresión
        canvas.height = boxHeight * 3;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(
          img,
          srcX, srcY, cropWidth, cropHeight,
          0, 0, canvas.width, canvas.height
        );
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch {
      resolve(null);
    }
  });
}

// ─── Código de barras Code128B sin librerías ──────────────────────────────────
function generateBarcodeDataUrl(text, barWidth = 3.2, barHeight = 260) {
  const CODE128B = [
    [2,1,2,2,2,2],[2,2,2,1,2,2],[2,2,2,2,2,1],[1,2,1,2,2,3],[1,2,1,3,2,2],
    [1,3,1,2,2,2],[1,2,2,2,1,3],[1,2,2,3,1,2],[1,3,2,2,1,2],[2,2,1,2,1,3],
    [2,2,1,3,1,2],[2,3,1,2,1,2],[1,1,2,2,3,2],[1,2,2,1,3,2],[1,2,2,2,3,1],
    [1,1,3,2,2,2],[1,2,3,1,2,2],[1,2,3,2,2,1],[2,2,3,2,1,1],[2,2,1,1,3,2],
    [2,2,1,2,3,1],[2,1,3,2,1,2],[2,2,3,1,1,2],[3,1,2,1,3,1],[3,1,1,2,2,2],
    [3,2,1,1,2,2],[3,2,1,2,2,1],[3,1,2,2,1,2],[3,2,2,1,1,2],[3,2,2,2,1,1],
    [2,1,2,1,2,3],[2,1,2,3,2,1],[2,3,2,1,2,1],[1,1,1,3,2,3],[1,3,1,1,2,3],
    [1,3,1,3,2,1],[1,1,2,3,1,3],[1,3,2,1,1,3],[1,3,2,3,1,1],[2,1,1,3,1,3],
    [2,3,1,1,1,3],[2,3,1,3,1,1],[1,1,2,1,3,3],[1,1,2,3,3,1],[1,3,2,1,3,1],
    [1,1,3,1,2,3],[1,1,3,3,2,1],[1,3,3,1,2,1],[3,1,3,1,2,1],[2,1,1,3,3,1],
    [2,3,1,1,3,1],[2,1,3,1,1,3],[2,1,3,3,1,1],[2,1,3,1,3,1],[3,1,1,1,2,3],
    [3,1,1,3,2,1],[3,3,1,1,2,1],[3,1,2,1,1,3],[3,1,2,3,1,1],[3,3,2,1,1,1],
    [3,1,4,1,1,1],[2,2,1,4,1,1],[4,3,1,1,1,1],[1,1,1,2,2,4],[1,1,1,4,2,2],
    [1,2,1,1,2,4],[1,2,1,4,2,1],[1,4,1,1,2,2],[1,4,1,2,2,1],[1,1,2,2,1,4],
    [1,1,2,4,1,2],[1,2,2,1,1,4],[1,2,2,4,1,1],[1,4,2,1,1,2],[1,4,2,2,1,1],
    [2,4,1,2,1,1],[2,2,1,1,1,4],[4,1,3,1,1,1],[2,4,1,1,1,2],[1,3,4,1,1,1],
    [1,1,1,2,4,2],[1,2,1,1,4,2],[1,2,1,2,4,1],[1,1,4,2,1,2],[1,2,4,1,1,2],
    [1,2,4,2,1,1],[4,1,1,2,1,2],[4,2,1,1,1,2],[4,2,1,2,1,1],[2,1,2,1,4,1],
    [2,1,4,1,2,1],[4,1,2,1,2,1],[1,1,1,1,4,3],[1,1,1,3,4,1],[1,3,1,1,4,1],
    [1,1,4,1,1,3],[1,1,4,3,1,1],[4,1,1,1,1,3],[4,1,1,3,1,1],[1,1,3,1,4,1],
    [1,1,4,1,3,1],[3,1,1,1,4,1],[4,1,1,1,3,1],[2,1,1,4,1,2],[2,1,1,2,1,4],
    [2,1,1,2,3,2],[2,3,3,1,1,1],[1,1,2,1,1,4],
  ];
  const START_B = 104, STOP = 106;
  const symbols = [START_B];
  let checksum = START_B;
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i) - 32;
    if (code < 0 || code > 95) continue;
    symbols.push(code);
    checksum += code * (i + 1);
  }
  symbols.push(checksum % 103);
  symbols.push(STOP);

  const qz = 8;
  let totalW = qz * 2;
  for (const s of symbols) totalW += (CODE128B[s] || [0,0,0,0,0,0]).reduce((a,b)=>a+b,0);
  totalW += 2; // barra final STOP

  const cw = Math.ceil(totalW * barWidth);
  const ch = Math.ceil(barHeight);
  const canvas = document.createElement("canvas");
  canvas.width = cw; canvas.height = ch;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.imageSmoothingEnabled = false;
  ctx.fillStyle = "#fff"; ctx.fillRect(0,0,cw,ch);

  let x = qz * barWidth, bar = true;
  for (const s of symbols) {
    for (const w of (CODE128B[s] || [])) {
      if (bar) {
        const drawX = Math.round(x);
        const drawW = Math.max(1, Math.round(w * barWidth));
        ctx.fillStyle="#000";
        ctx.fillRect(drawX, 0, drawW, ch);
      }
      x += w * barWidth; bar = !bar;
    }
  }
  ctx.fillStyle="#000";
  ctx.fillRect(Math.round(x), 0, Math.max(1, Math.round(2 * barWidth)), ch);
  return canvas.toDataURL("image/png");
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function formatFecha(f) {
  if (!f) return '';
  const p = String(f).split('-');
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : f;
}

function calcularVigencia(vigenciaCredencial) {
  const inicio = vigenciaCredencial?.fecha_inicio ? formatFecha(vigenciaCredencial.fecha_inicio) : 'N/A';
  const fin = vigenciaCredencial?.fecha_fin ? formatFecha(vigenciaCredencial.fecha_fin) : 'N/A';
  return { inicio, fin };
}

// ─── Credencial principal ─────────────────────────────────────────────────────
/**
 * Genera PDF A4 portrait con FRENTE y REVERSO de la credencial apilados verticalmente.
 * Ambas tarjetas: 85.6×54 mm (CR80 estándar — tamaño real de credencial). Marcas de corte en cada esquina.
 */
export async function generateCredencialPDF({ student, periodo = '', cicloIngreso = '', consecutivo = '001', descargar = false }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const pageW = 210;
  const pageH = 297;

  // ── Dimensiones de cada tarjeta (CR80 real: 85.6 × 54 mm) ──
  const CARD_W = 85.6;
  const CARD_H = 54;
  const GAP    = 15;  // separación vertical entre frente y reverso

  // Origen de cada tarjeta: centrado horizontal, posicionado en la parte superior
  const fx = (pageW - CARD_W * 2 - GAP) / 2;
  const fy = 20;
  const bx = fx + CARD_W + GAP;
  const by = fy;

  // Shorthand
  const FX = x => fx + x;
  const FY = y => fy + y;
  const BX = x => bx + x;
  const BY = y => by + y;

  // ── Assets ──
  const logoDataUrl  = await loadLogoDataUrl();
  const matricula    = String(student.matricula || student.id_estudiante || 'SIN-MATRICULA');
  const cicloEscolarBarcode = String(
    cicloIngreso ||
    student.ciclo_escolar_nombre ||
    student.ciclo_ingreso_nombre ||
    student.ciclo_ingreso?.nombre_ciclo ||
    student.ciclo_ingreso?.nombre ||
    ''
  );
  const consec       = String(consecutivo).padStart(3, '0');
  // Contenido del código de barras: MATÍCULA-CICLO_INGRESO-CONSECUTIVO
  const barcodeText  = cicloEscolarBarcode ? `${matricula}-${cicloEscolarBarcode}-${consec}` : `${matricula}-${consec}`;
  // Render high-res barcode and then scale down in PDF for a crisp print result.
  const barcodeDataUrl = generateBarcodeDataUrl(barcodeText, 3.2, 260);
  const nombre         = student.nombre_completo || student.nombre || '';

  // Foto de perfil (si existe en documentos PROFILE)
  const profileDoc = Array.isArray(student?.documentos)
    ? student.documentos.find((d) => d?.tipo_documento === 'PROFILE')
    : null;
  const base = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
  const mediaBase = base.replace('/api', '');
  const fotoPerfilUrl =
    profileDoc?.archivo_url ||
    (profileDoc?.url ? `${mediaBase}${profileDoc.url}` : null) ||
    (profileDoc?.ruta_archivo ? `${mediaBase}/media/${profileDoc.ruta_archivo}` : null);
  // Hacer crop center para llenar 19×25mm sin distorsionar (como object-fit: cover)
  const fotoPerfilDataUrl = await cropCenterImage(fotoPerfilUrl, 19, 25);

  // ── Helper: marcas de corte ──
  const drawCropMarks = (ox, oy) => {
    const CL = 3, CG = 1.5;
    doc.setDrawColor(0,0,0);
    doc.setLineWidth(0.15);
    // Superior-izquierda
    doc.line(ox-CG-CL, oy,         ox-CG,    oy);
    doc.line(ox,       oy-CG-CL,   ox,        oy-CG);
    // Superior-derecha
    doc.line(ox+CARD_W+CG, oy,     ox+CARD_W+CG+CL, oy);
    doc.line(ox+CARD_W,    oy-CG-CL, ox+CARD_W,      oy-CG);
    // Inferior-izquierda
    doc.line(ox-CG-CL, oy+CARD_H,   ox-CG,    oy+CARD_H);
    doc.line(ox,       oy+CARD_H+CG, ox,        oy+CARD_H+CG+CL);
    // Inferior-derecha
    doc.line(ox+CARD_W+CG, oy+CARD_H,   ox+CARD_W+CG+CL, oy+CARD_H);
    doc.line(ox+CARD_W,    oy+CARD_H+CG, ox+CARD_W,       oy+CARD_H+CG+CL);
  };

  drawCropMarks(fx, fy);
  drawCropMarks(bx, by);

  // ══════════════════════════════════════════════════════════════════════════════
  // FRENTE
  // ══════════════════════════════════════════════════════════════════════════════
  const PAD = 2.5;
  const LOGO_SIZE = 11;

  doc.setFillColor(255,255,255);
  doc.rect(FX(0), FY(0), CARD_W, CARD_H, "F");

  // Logo
  if (logoDataUrl) {
    doc.addImage(logoDataUrl, "PNG", FX(PAD), FY(PAD), LOGO_SIZE, LOGO_SIZE);
  }

  // Título "Universidad Lux"
  const titleCX_f = PAD + LOGO_SIZE + 2 + (CARD_W - PAD - LOGO_SIZE - 2 - PAD) / 2;
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0,0,0);
  doc.text("Universidad Lux", FX(titleCX_f), FY(PAD + 5.5), { align: "center" });

  // Ancla vertical del encabezado (sin línea visible)
  const H_SEP_F = PAD + LOGO_SIZE + 2;

  // Foto (derecha, pegada al borde derecho)
  const PHOTO_W = 19;
  const PHOTO_H = 25;
  const photoX_f = CARD_W - PAD - PHOTO_W;
  const photoY_f = H_SEP_F + 2;
  if (fotoPerfilDataUrl) {
    // Foto ya hace crop center, así que ocupa todo el espacio (28×36mm)
    doc.addImage(fotoPerfilDataUrl, "JPEG", FX(photoX_f), FY(photoY_f), PHOTO_W, PHOTO_H);
    doc.setDrawColor(100,100,100);
    doc.setLineWidth(0.2);
    doc.rect(FX(photoX_f), FY(photoY_f), PHOTO_W, PHOTO_H);
  } else {
    doc.setDrawColor(100,100,100);
    doc.setLineWidth(0.3);
    doc.rect(FX(photoX_f), FY(photoY_f), PHOTO_W, PHOTO_H);
  }

  // Matrícula debajo de la foto
  doc.setFontSize(6);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(100,100,100);
  doc.text(matricula, FX(photoX_f + PHOTO_W / 2), FY(photoY_f + PHOTO_H + 2.5), { align: "center" });

  // Datos alumno (izquierda de la foto)
  const DATA_MAX_W = photoX_f - PAD - 1.5;
  let ly = H_SEP_F + 3.5;

  doc.setFontSize(5.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0,0,0);
  doc.text("Alumno (a)", FX(PAD), FY(ly));
  ly += 3.5;

  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  const nombreLines = doc.splitTextToSize(nombre, DATA_MAX_W);
  doc.text(nombreLines, FX(PAD), FY(ly));
  ly += nombreLines.length * 3.5 + 2;

  const fechaNac = formatFecha(student.fecha_nacimiento || student.fechaNacimiento || '');
  doc.setFontSize(5.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(60,60,60);
  doc.text("Fecha de Nacimiento", FX(PAD), FY(ly));
  ly += 3;
  doc.setFont("helvetica", "normal");
  doc.text(fechaNac || 'No registrada', FX(PAD), FY(ly));
  ly += 4;

  const seccion = student.seccion_nombre || student.seccion || student.programa || '';
  doc.setFont("helvetica", "bold");
  doc.text("Sección", FX(PAD), FY(ly));
  ly += 3;
  doc.setFont("helvetica", "normal");
  const secLines = doc.splitTextToSize(seccion || '-', DATA_MAX_W);
  doc.text(secLines, FX(PAD), FY(ly));
  ly += secLines.length * 3.5 + 2;

  const programa = student.programa_nombre || student.programa || '';
  if (programa) {
    doc.setFont("helvetica", "bold");
    doc.text("Programa", FX(PAD), FY(ly));
    ly += 3;
    doc.setFont("helvetica", "normal");
    const progLines = doc.splitTextToSize(programa, DATA_MAX_W);
    doc.text(progLines, FX(PAD), FY(ly));
    ly += progLines.length * 3.5 + 2;
  }

  const campus = student.campus_nombre || student.campus || '';
  if (campus) {
    doc.setFont("helvetica", "bold");
    doc.text("Campus", FX(PAD), FY(ly));
    ly += 3;
    doc.setFont("helvetica", "normal");
    doc.text(campus, FX(PAD), FY(ly));
    ly += 4.5;
  }

  const grupo = student.grupo || student.nombre_grupo || student.clave_grupo || '';
  if (grupo) {
    doc.setFont("helvetica", "bold");
    doc.text("Grupo", FX(PAD), FY(ly));
    ly += 3;
    doc.setFont("helvetica", "normal");
    doc.text(grupo, FX(PAD), FY(ly));
  }

  // ══════════════════════════════════════════════════════════════════════════════
  // REVERSO
  // ══════════════════════════════════════════════════════════════════════════════
  doc.setFillColor(255,255,255);
  doc.rect(BX(0), BY(0), CARD_W, CARD_H, "F");

  let ry = PAD + 4;

  // Código de barras (ancho completo)
  const BAR_W = CARD_W - PAD * 2;
  const BAR_H = 10;
  if (barcodeDataUrl) {
    doc.addImage(barcodeDataUrl, "PNG", BX(PAD), BY(ry), BAR_W, BAR_H);
  }
  ry += BAR_H + 1;
  doc.setFontSize(5.5);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(80,80,80);
  doc.text("Código de identificación", BX(CARD_W / 2), BY(ry), { align: "center" });
  ry += 3.5;

  // Separador
  doc.setDrawColor(150,150,150);
  doc.setLineWidth(0.2);
  doc.line(BX(PAD), BY(ry), BX(CARD_W - PAD), BY(ry));
  ry += 4;

  // Vigencia (desde la inscripción más reciente del estudiante)
  const { inicio, fin } = calcularVigencia(student?.vigencia_credencial);
  doc.setFontSize(6);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0,0,0);
  doc.text(`Vigencia: del ${inicio} al ${fin}`, BX(CARD_W / 2), BY(ry), { align: "center" });
  ry += 5;

  // Dirección centrada
  doc.setFontSize(6);
  const addr = "Ave. Venustiano Carranza Nte. 614 Centro\nCP 64000 Monterrey";
  const addrLines = doc.splitTextToSize(addr, BAR_W);
  doc.text(addrLines, BX(CARD_W / 2), BY(ry), { align: "center" });
  ry += addrLines.length * 4 + 5;

  // Líneas de firma
  const firmaW = (CARD_W - PAD * 2 - 8) / 2;
  const firma1X = PAD;
  const firma2X = PAD + firmaW + 8;
  doc.setDrawColor(0,0,0);
  doc.setLineWidth(0.25);
  doc.line(BX(firma1X), BY(ry), BX(firma1X + firmaW), BY(ry));
  doc.line(BX(firma2X), BY(ry), BX(firma2X + firmaW), BY(ry));

  doc.setFontSize(6);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(60,60,60);
  doc.text("Control Escolar",  BX(firma1X + firmaW / 2), BY(ry + 3), { align: "center" });
  doc.text("Firma del Alumno", BX(firma2X + firmaW / 2), BY(ry + 3), { align: "center" });

  // ── Descargar o devolver ──
  if (descargar) {
    const safe = (nombre || matricula).replace(/[^A-Za-z0-9_\- ]/g,'').replace(/\s+/g,'_');
    doc.save(`credencial_${safe}.pdf`);
  }
  return doc.output("datauristring");
}
